import { createSelector } from 'reselect';
import basketSelector from 'selectors/basket/basketSelector';
import { BASKET_TYPES } from 'actions/ActionsConstants';

const hasSameDayItemsSelector = createSelector(basketSelector, basket => {
    const sameDayItems = basket?.itemsByBasket?.find(e => e.basketType === BASKET_TYPES.SAMEDAY_BASKET);

    return (sameDayItems?.itemsCount ?? 0) > 0;
});

export { hasSameDayItemsSelector };
